import { create } from "zustand";

import { EmailType } from "@interfaces/campaign.type";

interface ICampaignEmailStore {
  clearSelectedEmailList: () => void;
  emailList: EmailType[];
  scheduledDateTime: Date | null;
  selectedEmailList: number[];
  sendOptions: string;
  setEmailList: (emailList: EmailType[]) => void;
  setScheduledDateTime: (scheduledDateTime: Date | null) => void;
  setSelectedEmailList: (selectedEmailList: number[]) => void;
  setSendOptions: (sendOptions: string) => void;
}

const useCampaignEmailStore = create<ICampaignEmailStore>((set) => ({
  clearSelectedEmailList: () => set({ selectedEmailList: [] }),
  emailList: [],
  scheduledDateTime: null,
  selectedEmailList: [],
  sendOptions: "send",
  setEmailList: (emailList) => set({ emailList }),
  setScheduledDateTime: (scheduledDateTime) => set({ scheduledDateTime }),
  setSelectedEmailList: (selectedEmailList) => set({ selectedEmailList }),
  setSendOptions: (sendOptions) => set({ sendOptions }),
}));

export default useCampaignEmailStore;
